import { Medication } from '@novaheal/types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { axios } from 'utils/axios';
import { parse } from 'flatted';
import { parseMedication } from '@novaheal/parsers';

export const getMedication = async (id: string): Promise<Medication | null> => {
  const response = await axios.get(`/ctf/medication/${id}`);
  const parsedMedication = parseMedication(parse(response.data.data));
  return parsedMedication;
};

export const useMedicationApi = (id: string | undefined): UseQueryResult<Medication, unknown> => {
  return useQuery({
    queryKey: [`medication-${id}`], // Key for caching the query
    queryFn: () => getMedication(id as string),
    enabled: !!id,
    retry: 1,
  });
};
